import React, { FC, useMemo, useState } from "react"
import { DropDownItem, TextInputWithDropdown } from "../TextInputWithDropdown"
import { Controller, useFormContext } from "react-hook-form"
import { PostAJobModalFormValues } from "./types"
import { useCreativeWorkTypesFilter } from "../Filters/hooks/useCreativeWorkTypesFilter"
import { InputErrorText } from "../InputErrorText"

interface Props {
  displayValue: string
  onChangeDisplayValue: (value: string) => void
}

export const WorkTypeInput: FC<Props> = ({ displayValue, onChangeDisplayValue }) => {
  const { setValue, control } = useFormContext<PostAJobModalFormValues>()

  const creativeWorkTypes = useCreativeWorkTypesFilter()

  const typesSearched = useMemo(
    () => creativeWorkTypes.filter(edge => edge?.node?.name.toLowerCase().includes(displayValue?.toLowerCase())),
    [creativeWorkTypes, displayValue]
  )

  const dropDownItems = useMemo(() => {
    return typesSearched?.map(edge => ({
      id: edge?.node?.id!,
      display: edge?.node?.name!,
      indefiniteArticle: edge?.node?.indefiniteArticle!,
    }))
  }, [typesSearched])

  const onClickDropDownItem = (item: DropDownItem) => {
    setValue("workType", {
      value: item.id,
      display: item.display,
      indefiniteArticle: item.indefiniteArticle,
    })
    onChangeDisplayValue(item.display)
  }

  return (
    <Controller
      name="workType"
      control={control}
      rules={{}}
      render={({ field, fieldState: { error } }) => (
        <div className="flex flex-1 flex-col">
          <TextInputWithDropdown
            size="large"
            className="flex flex-1 flex-row"
            id="project-name-input"
            dropDownClassName="max-h-[220px] overflow-scroll"
            inputValue={displayValue}
            dropdownItems={dropDownItems}
            inputProps={{
              placeholder: "Project type",
              className: "text-primary-3 w-full",
              onChange: e => {
                setValue("workType", {
                  value: "",
                  display: "",
                  indefiniteArticle: "",
                })
                onChangeDisplayValue(e.target.value)
              },
            }}
            onClickDropDownItem={onClickDropDownItem}
          />
          {error?.message && <InputErrorText text={error.message} />}
        </div>
      )}
    />
  )
}
